import { isBuyRestricted } from '../../utils/fund-info';
import { getOpenTier, getIClassTier } from '../../summit-program/summit';

export const isFundUnlocked = ({
    summitTier,
    iClass,
    openToNewInvestors,
    openToSubsequentInvestments
}) =>
    !openToNewInvestors &&
    (getOpenTier(summitTier) || (iClass && getIClassTier(summitTier))) &&
    !isBuyRestricted(openToNewInvestors, openToSubsequentInvestments);
